module.exports = __webpack_public_path__ + "img/img_agreement.d8b20330.svg";